export default __webpack_public_path__ + "static/media/icon-share.958402ed.svg";